import React,  {useEffect,useState} from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Text from './Text';


const AttachFiles = ({uploadId})=> {
     


       
     
    // const location = useLocation();
    
    
    //const uploadId1= location.state.uploadId;
    const [fileItems, setFileItems] = useState([]);
    
    useEffect(() => {
         if(uploadId)
          {
            const formData = new FormData();
            console.log('테스트');
            console.log(uploadId);
            formData.append('uploadId', uploadId);
      
             axios.post('/uploadFileInfo', formData)
            .then((res) => {
               
                console.log(res.data);
                setFileItems(res.data);
                 
            })
          }
      //getFileItems();
        
    },[uploadId]);


    // const getFileItems =async () =>{
    //   const formData = new FormData();
    //   console.log(uploadId);
    //   formData.append('uploadId', uploadId);
 
    //   await axios.post('/uploadFileInfo', formData)
    //   .then((res) => {
    //     console.log(uploadId);
       
    //       console.log(res.data);
    //       setFileItems(res.data);
           
    //   })
      
   

    
    
     
    
    const downloadHandler = async (FileID, FileNm) => {
        // 파일 데이터 조회(!중요! responseType에 blob으로 준다, arryBuffer을 주는 방법도 있는것 같다.)
        // !!responseType을 설정해주는 위치를 헷갈리지 말자(Header에 주는게 아니다)!!
        console.log(FileID);
        console.log(FileNm);
        const axiosResponse = await axios.get(`/downloadFile?fileId=${FileID}`,{"responseType" : "blob"});
    
        // a태그 Element를 생성해준다.
        const aElement = document.createElement('a');
        // 위에서 생성한 aElement변수에 href속성에 넣을 데이터를 설정해준다.
        const blobFile = window.URL.createObjectURL(new Blob([axiosResponse.data]));
        aElement.href = blobFile;
        
        // !중요! 파일명 설정 부분이다.
        // download속성에는 확장자를 포함한 파일명 값이 들어간다.
        // 서버에서 응답데이터를 binary 파일 데이터만 줄것이다.
        // 파일명을 설정해야 할텐데 파일명은 Header의 값중 content-disposition에 들어있다.(없다면 백엔드개발자에게 넣어 달라고하자)
        // content-disposition에 undefined로 나올 경우 서버쪽에서 해당 Header에 접근 할수 있도록 설정을 해줘야한다.(CORS)
        // contentDisposition = attachment; filename=test.png
        const contentDisposition:string = axiosResponse.headers['content-disposition'];
        if(contentDisposition) {
          // X이부분은 참고하지말자 너무 위험하다..X
          //const filename = contentDisposition.split(';')[1].trim().split('=')
          // 파일명 설정
          aElement.download = FileNm;
        }
    
        // document body 위에 생성한 a태그를 부착 시킨다.
        document.body.appendChild(aElement);
    
        // 부착 시킨 a태그를 Click!(이벤트 발생 시키기) 그러면 다운로드가 된다.
        aElement.click();
        setTimeout(() => {
          // 이제 더이상 필요 없으니 생성한 a태그를 1초후 삭제 시켜준다.
          aElement.remove();
        }, 1000);
      }


      
      return (
        <div style={{ width: 'auto', flexDirection:'column', float: 'right'}}>
          <div style={{
            float: 'left',
            
            }} >
          </div>
          <div style={{  marginTop: '0px', padding: '0', listStyle:'', maxHeight: '200px', overflow: 'auto', float:'left' }}>
            {fileItems.map(item => (
              <Text variant='px20w400B_det'>
                <div
                  key={item.FileID}
                  onClick={() => downloadHandler(item.FileID,item.FileNm)}
                >
                  {item.FileNm}
                </div>  
              </Text>

            ))}
          </div>
         
        
      </div>
     );
      
 };

export default AttachFiles;
 